/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect} from "react";
import {Link} from "react-router-dom";
import Loader from "../Common/Loader";
import useStateCallback from "../../util/customHooks/useStateCallback";
import AttachCard from "./AttachCard";
import UpdateCardNumber from "./UpdateCardNumber";
import CardContext from "../../Context/CardContext";
import Pagination from "../Common/Pagination";
import StudentCardSearchForm from "../Common/StudentCard/StudentCardSearchForm";
import DeleteCard from "./DeleteCard";

function UnassignedCards(props) {
  const [modal, setModal] = useStateCallback(false);
  const {getCards, getAssignedCards, getInactiveCards, page, assignedPage, unassignedPage, inactivePage, unassignedMeta, setUnassignedPage, unassignedFirst, unassignedQuery, setUnassignedQuery,
     loading, loading2, unassignedCardList, countAllCards, getUnassignedCards, searchUnassignedCard, countAssignedCards, countAssignedWristbands} = useContext(CardContext);

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= unassignedMeta.length) {
      setUnassignedPage(newPage);
    }
  };

    const setCards = (e) => {
      e.preventDefault();
      setUnassignedQuery("");
      setUnassignedPage(1);
      getUnassignedCards(1);
    };
  
    useEffect(() => {
      if (unassignedQuery) {
        searchUnassignedCard();
      } else {
        getUnassignedCards(unassignedPage);
      }
    }, [unassignedPage]);


  const attachCard=(e,item)=>{
    setModal(false, ()=>setModal(<AttachCard cardID={item.card_id} cardNumber={item.card_number} getAllCards={getCards} getAssignedCards={getAssignedCards} getInactiveCards={getInactiveCards} 
      getUnassignedCards={getUnassignedCards} page={page} assignedPage={assignedPage} inactivePage={inactivePage} unassignedPage={unassignedPage} countAssignedCards={countAssignedCards} 
      countAssignedWristbands={countAssignedWristbands} isOpen={true}/>))
  }
  
  const updateCard=(e,item)=>{
    setModal(false, ()=>setModal(<UpdateCardNumber cardID={item.card_id} cardNumber={item.card_number} cardType={item.type} getAllCards={getCards} page={page} isOpen={true}/>))
  }

  const deleteCard=(e,item)=>{
    setModal(false, ()=>setModal(<DeleteCard cardID={item.card_id} cardNumber={item.card_number} getAllCards={getCards} page={page} getUnassignedCards={getUnassignedCards}
      unassignedPage={unassignedPage} countAllCards={countAllCards} isOpen={true}/>))
  }

    return (
        <>
      {modal}
      
      <StudentCardSearchForm searchTerm={unassignedQuery} setSearchTerm={setUnassignedQuery} placeholder="Enter card / wristband number..." searchCards={searchUnassignedCard} setCards={setCards} setPage={setUnassignedPage}/>
        <div className="table-responsive">
{loading || loading2 ? (
<Loader /> // Show loader when loading or searching
) : (
<table className="table display data-table text-nowrap">
<thead>
<tr>
<th scope="col" className="wd-10p">No.</th>
<th>Serial Number</th>
<th>Type</th>
<th>Status</th>
<th>Actions</th>
</tr>
</thead>
<tbody>
{unassignedCardList.length > 0 ? (
unassignedCardList.map((item, index) => (
  <tr key={index}>
    <th scope='row' style={{width:"5px"}}>{index + unassignedFirst + 1}</th>
    <td>{item.card_number}</td>
    <td>{item.type==="CARD"?<span class="badge badge-info">{item.type}</span>:<span class="badge badge-wb">{item.type}</span>}</td>
          <td><span class="badge badge-warning">Unassigned</span></td>
          <td>
            <div className="dropdown">
              <Link
                to="#"
                className="dropdown-toggle"
                data-toggle="dropdown"
                aria-expanded="false">
                <span className="flaticon-more-button-of-three-dots"></span>
              </Link>
              <div className="dropdown-menu dropdown-menu-right">
               
              <Link
                className="dropdown-item"
                to="#"
                onClick={(e) => updateCard(e,item)}>
                <i className="fa fa-edit mr-1"></i>
                 Change Serial Number
              </Link>
                <Link
                className="dropdown-item"
                to="#"
                onClick={(e) => attachCard(e,item)}>
                <i className="fa fa-square-plus mr-1" style={{color:"green"}}></i>
                 Attach Student
              </Link>
              
              <Link
                className="dropdown-item"
                to="#"
                onClick={(e) => deleteCard(e,item)}>
                <i className="fa fa-trash mr-1"></i>
                 Delete
              </Link></div>
            </div>
          </td>
  </tr>
))
) : (
<tr>
  <td colSpan="5" style={{ textAlign: "center" }}>
    No cards registered yet.
  </td>
</tr>
)}
</tbody>
</table>
)}
        </div>
        <Pagination currentPage={unassignedPage} totalPages={unassignedMeta.length} onPageChange={handlePagination}/>

         </>
  );
}

export default UnassignedCards;
